//页面中常用的url及处理函数

//somegbinfoheaderOne.js
  var url1 = "http://iguba.eastmoney.com/action.aspx";
  var urlmain = "http://iguba.eastmoney.com/gubaapi/v3/"
  var url2 = "http://iguba.eastmoney.com/gubaapi/v3/write/Guba/Follow/FollowGuba.aspx?pi=ecp&isweb=true&deviceid=&version=3.1.1&product=Guba&plat=Web";
  var url3 = "http://iguba.eastmoney.com/gubaapi/v3/write/Guba/Follow/CancelFollowGuba.aspx?pi=ecp&isweb=true&deviceid=&version=3.1.1&product=Guba&plat=Web";
  // var url: "http://nufm.dfcfw.com/EM_Finance2014NumericApplication/JS.aspx?type=CT&cmd=0000011,3990012,0003001,3990052,3990062&sty=SHSTHD&st=z&sr=&p=&ps=&cb=?&js=&token=5c46f660fab8722944521b8807de07c0",

function parseUrl(urlStr){
	var parser = document.createElement('a');
	parser.href = urlStr;

	parser.protocol; // => "http:"
	parser.hostname; // => "example.com"
	parser.port;     // => "3000"
	parser.pathname; // => "/pathname/"
	parser.search;   // => "?search=test"
	parser.hash;     // => "#hash"
	parser.host;     // => "example.com:3000"

	var ret = {
		url:urlStr,
		protocol:parser.protocol,
		hostname:parser.hostname,
		port:parser.port,
		pathname:parser.pathname,
		search:parser.search,
		hash:parser.hash,
		host:parser.host
	};
	return ret;
}

function ChangeParams(name, value) //更改地址栏的参数
{
    var param = window.location.search; //?code=600015&paixu=0&type=1
    // var param = "?code=600015&paixu=0&type=1"
    var paramArr = param.split('&');
    var obj = {};
    for(var i = 1; i<paramArr.length;i++){
      var item = paramArr[i].split('=');
      obj[item[0]] = item[1]
    }

    obj[name] = value; //存在则改值，不存在则加值
     var curparam = paramArr[0]
    for(var i in obj){
     curparam = curparam + '&' + i + '=' + obj[i];
    }
    return curparam;
}


function GetQueryString(name) //获取地址栏的参数值
{
		 var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
     var r = window.location.search.substr(1).match(reg);
     if(r!=null)return  unescape(r[2]); return null;
}


module.exports={
	parseUrl:parseUrl,
	ChangeParams: ChangeParams,
	GetQueryString: GetQueryString
}



//////////////////
// WEBPACK FOOTER
// ./src/module/helper/url.js
// module id = 4
// module chunks = 0